// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"d39f588b","315":"ce49c86a","409":"c0dcdc4c","631":"5a29d01e","771":"ab3fe8b6","774":"128f22ca","787":"b6fa63e8"}[chunkId] + ".chunk.js";
};